import React, { useState, useEffect, useRef } from "react";
import CanvasJSReact from "../../../../../../../lib/canvasjs/canvasjs.react";
import Loader from "../../../../../../settings/loader";
import commaNumber from "comma-number";
import "./style.scss";

const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJS.addColorSet("barChart4", [
  "#FFA32E",
  "#E38029",
  "#FA8039",
  "#E6693C",
  "#FA684B",
]);

function Page(props) {
  const [data, setData] = useState({
    result: null,
    cols: [],
    chart: [],
  });
  const [load, setLoad] = useState(0);
  const prevExport = useRef(props.export);

  // Initialize result when props.data is available
  useEffect(() => {
    if (props.data && load === 0) {
      setData((prev) => ({
        ...prev,
        result: props.data,
      }));
      setLoad(1);
    }
    // eslint-disable-next-line
  }, [props.data, load]);

  // Prepare chart data when result is set ---old one - without separate open close data.
  // useEffect(() => {
  //   if (load === 1 && data.result) {
  //     const chartData = data.result.chains.data.map((chain) => {
  //       const totalSales = data.result.sales.data
  //         .filter((sale) => sale.chaKey === chain.chaKey)
  //         .map((sale) => sale.total);

  //       let total = 0;
  //       if (totalSales.length) {
  //         total = totalSales.reduce((a, b) => a + b);
  //       }

  //       return {
  //         y: total,
  //         label:
  //           data.result.brands.data.find(
  //             (brand) => brand.braKey === chain.braKey
  //           ).name +
  //           " | " +
  //           chain.name,
  //         toolTipContent: `{label} :  {y} {currency}`,
  //         currency: chain?.currency?.toUpperCase(),
  //       };
  //     });

  //     setData((prev) => ({
  //       ...prev,
  //       chart: chartData,
  //     }));
  //     setLoad(2);
  //   }
  //   // eslint-disable-next-line
  // }, [load, data.result]);

  // Prepare chart data when result is set - new one - to show open/closed sales separately.
  useEffect(() => {
    if (load === 1 && data.result) {
      const chartData = data.result.chains.data.map((chain) => {
        const chainSales = data.result.sales.data.filter(
          (sale) => sale.chaKey === chain.chaKey
        );

        // Calculate open sales (status = 0)
        const openSales = chainSales
          .filter((sale) => sale.status === 0)
          .reduce((total, sale) => total + sale.total, 0);

        // Calculate closed sales (status = 1)
        const closedSales = chainSales
          .filter((sale) => sale.status === 1)
          .reduce((total, sale) => total + sale.total, 0);

        // Calculate total sales
        const totalSales = chainSales.reduce(
          (total, sale) => total + sale.total,
          0
        );

        const brandName =
          data.result.brands.data.find((brand) => brand.braKey === chain.braKey)
            ?.name || "Unknown Brand";

        const currency = chain?.currency?.toUpperCase() || "USD";

        return {
          y: totalSales,
          label: `${brandName} | ${chain.name}`,
          toolTipContent: `
          <div style="text-align: center; font-weight: bold; margin-bottom: 5px;">
            {label}
          </div>
          <div style="text-align: left;">
            <div>Open Sales: ${currency} ${commaNumber(
            openSales.toFixed(2)
          )}</div>
            <div>Closed Sales: ${currency} ${commaNumber(
            closedSales.toFixed(2)
          )}</div>
            <div style="border-top: 1px solid #ccc; margin-top: 5px; padding-top: 5px; font-weight: bold;">
              Total: ${currency} ${commaNumber(totalSales.toFixed(2))}
            </div>
          </div>
        `,
          currency: currency,
          openSales: openSales,
          closedSales: closedSales,
          totalSales: totalSales,
          chainName: chain.name,
          brandName: brandName,
        };
      });

      setData((prev) => ({
        ...prev,
        chart: chartData,
      }));
      setLoad(2);
    }
    // eslint-disable-next-line
  }, [load, data.result]);

  // Export logic
  useEffect(() => {
    if (prevExport.current !== props.export && load === 2) {
      prevExport.current = props.export;
      props.getData({
        type: "image",
        title: "Sales by Sales Summary",

        body: {
          table: [
            {
              head: [["Business Name", "Total"]],
              body: [
                ...data.chart.map((d) => [
                  d.label,
                  `${d?.currency?.toUpperCase()} ${commaNumber(
                    d.y.toFixed(2)
                  )}`,
                ]),
              ],
            },
          ],
          id: "exportPdf_Slide1",
        },
      });
    }
    // eslint-disable-next-line
  }, [props.export, load, data.chart, props.getData]);

  // Chart options -- new one - to show open/closed sales separately.
  // This is the new chart options that shows open and closed sales separately.
  // It uses the openSales and closedSales properties from the chart data.
  let options = {};
  const chainsCurrencies = data?.result?.chains?.data.map((item) =>
    item?.currency?.toLowerCase()
  );
  const isEqualCurr = chainsCurrencies?.every((val, i, arr) => val === arr[0]);

  if (load) {
    options.colorSet = "barChart4";
    options.axisY = {
      prefix: isEqualCurr ? `${props.data.currency.base.toUpperCase()}` : "",
    };
    options.axisX = {
      interval: 1,
      //labelAngle: -45, // Rotate labels for better readability
    };
    options.data = [
      {
        type: "column",
        yValueFormatString: "#,##0.00",
        dataPoints: data.chart,
      },
    ];
  }
  // Chart options ---old one - not showing open/closed separate.
  /*let options = {};
  const chainsCurrencies = data?.result?.chains?.data.map((item) =>
    item?.currency?.toLowerCase()
  );
  const isEqualCurr = chainsCurrencies?.every((val, i, arr) => val === arr[0]);

  if (load) {
    options.colorSet = "barChart4";
    options.axisY = {
      prefix: isEqualCurr ? `${props.data.currency.base.toUpperCase()}` : "",
    };
    options.axisX = {
      interval: 1,
    };
    options.data = [
      {
        type: "column",
        yValueFormatString: "#,##0.00",
        dataPoints: data.chart,
      },
    ];
  }*/

  if (data.result && data.result.chains.data.length <= 2 && options.axisX) {
    delete options.axisX.interval;
  }

  return (
    <div id={"exportPdf_Slide1"}>
      {!load || load < 2 ? <Loader /> : <CanvasJSChart options={options} />}
    </div>
  );
}

export default Page;
